import { connect } from 'react-redux'
import actions from 'actions/index'

const connectModal = (Component, modalName) => {
  const mapStateToProps = (state, ownProps) => ({
    isOpen: state.modals.openModals.indexOf(modalName) > -1,
    modalData: state.modals.openModalData[modalName] || {},
    isActiveModal: state.modals.activeModal === modalName,
  })

  const mapDispatchToProps = ({
    closeModal: actions.closeModal.bind(this, modalName),
    openModal: actions.openModal,
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Component)
}

export default connectModal



// WEBPACK FOOTER //
// ./src/connectModal.jsx